import React, { useCallback, useEffect, useState } from "react";
import Styles from './styles.module.scss';
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { registration, registrationFailure } from "../../store/main/action";

import logIcon from "../../theme/assets/svg/b_log_icon.svg";
import pasIcon from "../../theme/assets/svg/b_pas_icon.svg";
import showAIcon from "../../theme/assets/svg/b_pas_show_a_icon.svg";
import showPIcon from "../../theme/assets/svg/b_pas_show_p_icon.svg";

const RegMain = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { code } = useParams();

    const formErr = useSelector(store => store.main.registrationErr);

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [password_confirmation, setPassword_confirmation] = useState('');

    const [referralCode, setReferralCode] = useState(() => {
        return code || localStorage.getItem('referral_code') || '';
    });

    const [isShowPassword, setIsShowPassword] = useState(false);
    const [isShowPasswordConfirmation, setIsShowPasswordConfirmation] = useState(false);

    const getErrorMessage = (error) => {
        if (!error) return null;

        if (Array.isArray(error)) {
            return error[0] || null;
        }

        return error;
    };

    const clearFieldError = (fieldName) => {
        if (formErr?.[fieldName]) {
            const updatedErrors = { ...formErr };
            delete updatedErrors[fieldName];

            dispatch(registrationFailure(updatedErrors));
        }
    };

    const referralCodeChangeHandler = (event) => {
        const value = event.target.value.trim();

        setReferralCode(value);
        clearFieldError('referral_code');
    };

    const sendFormHandler = useCallback(() => {
        const payload = {
            email,
            password,
            password_confirmation,
        };

        const preparedReferralCode = referralCode.trim();

        if (preparedReferralCode) {
            payload.referral_code = preparedReferralCode;
        }

        dispatch(registration(payload));
    }, [
        dispatch,
        email,
        password,
        password_confirmation,
        referralCode,
    ]);

    useEffect(() => {
        if (!code) return;

        setReferralCode(code);
        localStorage.setItem('referral_code', code);
    }, [code]);

    useEffect(() => {
        const preparedReferralCode = referralCode.trim();

        if (preparedReferralCode) {
            localStorage.setItem('referral_code', preparedReferralCode);
            return;
        }

        localStorage.removeItem('referral_code');
    }, [referralCode]);

    useEffect(() => {
        const onKeyDown = e => {
            if (e.keyCode === 13) {
                sendFormHandler();
            }
        };

        document.addEventListener('keydown', onKeyDown);

        return () => {
            document.removeEventListener('keydown', onKeyDown);
        };
    }, [sendFormHandler]);

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap} ${Styles.pageContainer}`}>
                <div className={`${Styles.formWrap}`}>
                    <div className={`${Styles.formTitle}`}>
                        {t('Создайте аккаунт')}
                    </div>

                    <div className={`${Styles.formSubTitle}`}>
                        {t('Введите данные, чтобы стать клиентом NEXT')}
                    </div>

                    <div className={`${Styles.contentBox}`}>
                        <div className={`${Styles.inputWrap} ${formErr?.email ? Styles.inputWrapWithErr : ''}`}>
                            <div className={`${Styles.inputTitleRow}`}>
                                <div className={`${Styles.inputTitle}`}>
                                    {t('Почта')}
                                </div>
                            </div>

                            <div className={`${Styles.inputBox}`}>
                                <input
                                    type="text"
                                    placeholder="example@gmail.com"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    onKeyDown={() => clearFieldError('email')}
                                />

                                <div className={`${Styles.absLeft}`}>
                                    <img src={logIcon} alt={t('Почта')} />
                                </div>
                            </div>

                            <div className={`${Styles.tcErr} ${formErr?.email ? Styles.tcErrActive : ''}`}>
                                {getErrorMessage(formErr?.email)}
                            </div>
                        </div>

                        <div className={`${Styles.inputWrap} ${formErr?.password ? Styles.inputWrapWithErr : ''}`}>
                            <div className={`${Styles.inputTitleRow}`}>
                                <div className={`${Styles.inputTitle}`}>
                                    {t('Пароль')}
                                </div>
                            </div>

                            <div className={`${Styles.inputBox}`}>
                                <input
                                    type={isShowPassword ? "text" : "password"}
                                    placeholder="••••••••"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    onKeyDown={() => clearFieldError('password')}
                                />

                                <div className={`${Styles.absLeft}`}>
                                    <img src={pasIcon} alt={t('Пароль')} />
                                </div>

                                <div
                                    className={`${Styles.absRight}`}
                                    onClick={() => setIsShowPassword(!isShowPassword)}
                                >
                                    <img
                                        src={isShowPassword ? showPIcon : showAIcon}
                                        alt={t('Показать пароль')}
                                    />
                                </div>
                            </div>

                            <div className={`${Styles.tcErr} ${formErr?.password ? Styles.tcErrActive : ''}`}>
                                {getErrorMessage(formErr?.password)}
                            </div>
                        </div>

                        <div className={`${Styles.inputWrap} ${formErr?.password_confirmation ? Styles.inputWrapWithErr : ''}`}>
                            <div className={`${Styles.inputTitleRow}`}>
                                <div className={`${Styles.inputTitle}`}>
                                    {t('Подтвердите пароль')}
                                </div>
                            </div>

                            <div className={`${Styles.inputBox}`}>
                                <input
                                    type={isShowPasswordConfirmation ? "text" : "password"}
                                    placeholder="••••••••"
                                    value={password_confirmation}
                                    onChange={(e) => setPassword_confirmation(e.target.value)}
                                    onKeyDown={() => clearFieldError('password_confirmation')}
                                />

                                <div className={`${Styles.absLeft}`}>
                                    <img src={pasIcon} alt={t('Подтвердите пароль')} />
                                </div>

                                <div
                                    className={`${Styles.absRight}`}
                                    onClick={() => setIsShowPasswordConfirmation(!isShowPasswordConfirmation)}
                                >
                                    <img
                                        src={isShowPasswordConfirmation ? showPIcon : showAIcon}
                                        alt={t('Показать пароль')}
                                    />
                                </div>
                            </div>

                            <div className={`${Styles.tcErr} ${formErr?.password_confirmation ? Styles.tcErrActive : ''}`}>
                                {getErrorMessage(formErr?.password_confirmation)}
                            </div>
                        </div>

                        <div className={`${Styles.inputWrap} ${formErr?.referral_code ? Styles.inputWrapWithErr : ''}`}>
                            <div className={`${Styles.inputTitleRow}`}>
                                <div className={`${Styles.inputTitle}`}>
                                    {t('Реферальный код')}
                                </div>
                            </div>

                            <div className={`${Styles.inputBox}`}>
                                <input
                                    type="text"
                                    placeholder={t('Введите реферальный код')}
                                    value={referralCode}
                                    onChange={referralCodeChangeHandler}
                                    onKeyDown={() => clearFieldError('referral_code')}
                                />

                                <div className={`${Styles.absLeft}`}>
                                    <img src={logIcon} alt={t('Реферальный код')} />
                                </div>
                            </div>

                            <div className={`${Styles.tcErr} ${formErr?.referral_code ? Styles.tcErrActive : ''}`}>
                                {getErrorMessage(formErr?.referral_code)}
                            </div>
                        </div>
                    </div>

                    <div className={`${Styles.mainBtn}`} onClick={sendFormHandler}>
                        {t('Стать клиентом')}
                    </div>

                    <div className={`${Styles.sep}`} />

                    <div className={`${Styles.note}`}>
                        {t('Уже есть аккаунт?')}{" "}
                        <span onClick={() => navigate('/sign-in')}>
                            {t('Войти')}
                        </span>
                    </div>
                </div>

                <div className={`${Styles.imgWrap}`} />
            </div>
        </section>
    );
};

export default RegMain;